<template>
    <div class="mda">
      <div class="container">
            <el-row :gutter="20">
                <el-col :span="24">
                    <h3>MDA移动数据采集</h3>
                    <p>无需额外安装客户端，微信端集成，专有服务器对接，SSL通道，安全、方便快捷。</p>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_1.svg">
						</div>
						<h5>项目管理</h5>
						<p class="text-center">可通过移动端进行临床项目信息维护和管理。</p>
					</div>
                </el-col>
                <el-col :span="5">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_4.svg">
						</div>
						<h5>受试者管理</h5>
						<p class="text-center">CRC、PI可通过移动端进行受试者的录入与维护，支持身份证扫描自动入组，支持公安部接口进行人证一致性核验，确保受试者身份安全。 </p>
					</div>
                </el-col>
                <el-col :span="5">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/mda_ico_3.svg">
						</div>
						<h5>SDC/EDC访视数据管理</h5>
						<p class="text-center">在移动端可同时维护受试者SDC/EDC访视表单数据 </p>
					</div>
                </el-col>
                <el-col :span="5">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/mda_ico_4.svg">
						</div>
						<h5>OCR识别</h5>
						<p class="text-center">通过移动端可进行SDC原始单据拍照上传，自动识别单据数值、正常值范围 </p>
					</div>
                </el-col>
                <el-col :span="5">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/mda_ico_5.svg">
						</div>
						<h5>自动脱敏</h5>
						<p class="text-center">所有单据上传前自动脱敏，自动抹去受试者敏感信息，确保受试者信息保密 </p>
					</div>
                </el-col>
          </el-row>
          <section class="program-content">
              <el-row :gutter="20">
                <el-col :span="24">
                    <div class="section-title text-center">
                        <h3 class="sub-title">自上而下，从宏观到微观，让数据一览无余</h3>
                        <p class="title">从总览、项目、中心及受试者四个维度逐层可视化展示相关数据</p>
                        <p class="title">汇聚SDC, EDC, CCM及DCS多个平台数据进行准实时的展示</p>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <img src="@/assets/img/pro/mda_pic_1.jpg">
                </el-col>
                <el-col :span="12">
                    <div class="program-des">
                        <h3 class="text-blue">随时随地的移动端采集</h3>
                        <p>无需额外安装客户端，微信端集成，专有服务器对接，</p>
                        <p>SSL通道，安全、方便快捷。</p>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="program-des">
                        <h3 class="text-blue">身份证拍照入组、人脸识别+人证一致性核验</h3>
                        <p>无需额外安装客户端，微信端集成，专有服务器对接，</p>
                        <p>SSL通道，安全、方便快捷。</p>
                    </div>
                </el-col>
                <el-col :span="12">
                    <img src="@/assets/img/pro/mda_pic_2.jpg">
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <img src="@/assets/img/pro/mda_pic_3.jpg">
                </el-col>
                <el-col :span="12">
                    <div class="program-des">
                        <h3 class="text-blue">拍照上传，自动脱敏，智能识别</h3>
                        <p>无需额外安装客户端，微信端集成，专有服务器对接，</p>
                        <p>SSL通道，安全、方便快捷。</p>
                    </div>
                </el-col>
            </el-row>
          </section>
      </div>
    </div>
</template>
<script>

export default{
    data() {
        return {

        };
    },
    methods: {
      
    }
}
</script>
<style scoped>
.program-des {
    padding: 60px 30px 0;
    text-align: center;
}
.program-des h4{
  margin-bottom: 30px;
}
.single-service-inner {
  position: relative;
  border-radius: 8px;
  background: #fff;
  margin-bottom: 30px;
  /*box-shadow: 0px 5px 30px rgba(126, 86, 255, 0.1);*/
  transition: all 0.4s ease-in;
  /*clip-path: polygon(0 10%, 100% 0%, 100% 90%, 0% 100%);*/
  padding: 70px 10px 30px;
}
.page-service-area .single-service-inner {
  padding: 20px ;
}
.single-service-inner.style-2 {
  padding: 40px 40px 50px;
}
.single-service-inner.style-2 .thumb {
  margin-bottom: 23px;
}
.single-service-inner.style-2 .thumb img {
  width: auto;
}
.single-service-inner:hover {
  box-shadow: 0px 5px 30px rgba(126, 86, 255, 0.2);
}
.single-service-inner .thumb {
  margin-bottom: 35px;
}
.program-adv-area .single-service-inner .thumb img {
  
  max-height: 150px;
}
.single-service-inner h5 {
  margin-bottom: 14px;
  text-align: center;
}
.single-service-inner p {
  transition: all 0.4s ease-in;
}

.service--details-area p {
  font-size: 18px;
}
</style>